const PC_ASPIRE_COMMUNITY = "aspireCommunityProgramChoice";
const PC_ASPIRE_YEAR_11 = "aspireYear11ProgramChoice";
const PC_ASPIRE_ACA_EVE = "aspireOthersProgramChoice";
const PC_REGIONAL_BENEFITS = "regionalBenefitsProgramChoice";
const PC_ELITE_ATHLETE = "eliteAthleteProgramChoice";
const PC_RISE = "riseProgramChoice";
const PC_PRIORITY_ACCESS = "priorityAccessProgramChoice";
const PC_SEAS = "seasProgramChoice";
const PC_TERTIARY_STUDY = "tertiaryStudyProgramChoice";
const PC_WORK_LIFE = "workLifeProgramChoice";
const PC_UNI_SUBJECTS = "universitySubjectsProgramChoice";
const YEAR_12_NO_ATAR = "currentYear12noATAR";
const YEAR_12_WITH_ATAR = "currentYear12withATAR";
const YEAR_11_FAILING = "currentYear11Failing";
const YEAR_11_PASSING = "currentYear11Passing";

document.addEventListener("alpine:init", () => {
  Alpine.store("courseInfo", {
    courseName: "",
    displayedCourseName: null,
    discipline: "",
    disciplineList: [],
    showDisciplineList: false,
    showAutocomplete: false,
    showGenericTPP: false,
  }),
    Alpine.data("pathwaySelection", () => ({
      availableCourses: courseData.map((course) => course.dreamCourse),
      availableDisciplines: courseData.map((course) => course.discipline),
      fullDisciplineName: function (discipline) {
        switch (discipline) {
          case "as":
            return "Arts, social sciences and communications";
          case "bc":
            return "Business and commerce";
          case "ed":
            return "Education and teaching";
          case "he":
            return "Health";
          case "it":
            return "Information Technology";
          case "en":
            return "Engineering";
          case "la":
            return "Law";
          case "cr":
            return "Criminology";
          case "sc":
            return "Science";
          case "md":
            return;
          default:
            console.warn(
              discipline,
              " does not have a full discipline name associated with it."
            );
            return "-";
        }
      },
      isDreamCourse: "",
      atarRange: "",
      preferredOption: "",
      studentType: "",
      ATARChoice: "",
      failingYear11Choice: "",
      journey: "",
      journeys: {
        currentYear11Passing: [
          // PC_ASPIRE_YEAR_11,
          PC_ASPIRE_ACA_EVE,
          PC_ASPIRE_COMMUNITY,
          PC_UNI_SUBJECTS,
          PC_REGIONAL_BENEFITS,
          PC_ELITE_ATHLETE,
          PC_RISE,
          PC_PRIORITY_ACCESS,
          PC_SEAS,
        ],
        currentYear11Failing: [PC_UNI_SUBJECTS, PC_RISE],
        currentYear12withATAR: [
          // PC_ASPIRE_YEAR_11,
          PC_ASPIRE_ACA_EVE,
          PC_ASPIRE_COMMUNITY,
          PC_UNI_SUBJECTS,
          PC_REGIONAL_BENEFITS,
          PC_ELITE_ATHLETE,
          PC_RISE,
          PC_PRIORITY_ACCESS,
          PC_SEAS,
        ],
        currentYear12noATAR: [
          PC_ASPIRE_COMMUNITY,
          PC_UNI_SUBJECTS,
          PC_RISE,
          PC_TERTIARY_STUDY,
        ],
        previousYear12: [
          PC_ASPIRE_COMMUNITY,
          PC_ELITE_ATHLETE,
          PC_RISE,
          PC_SEAS,
        ],
        noATAR: [
          PC_ASPIRE_COMMUNITY,
          PC_RISE,
          PC_SEAS,
          PC_TERTIARY_STUDY,
          PC_WORK_LIFE,
        ],
      },
      programs: {
        [PC_ASPIRE_COMMUNITY]: "",
        [PC_ASPIRE_YEAR_11]: "",
        [PC_REGIONAL_BENEFITS]: "",
        [PC_ELITE_ATHLETE]: "",
        [PC_RISE]: "",
        [PC_PRIORITY_ACCESS]: "",
        [PC_SEAS]: "",
        [PC_TERTIARY_STUDY]: "",
        [PC_WORK_LIFE]: "",
        [PC_UNI_SUBJECTS]: "",
      },
      courseExists: false,
      getJourneyPath: function () {
        if (this.journey === "currentYear12") {
          if (this.ATARChoice === "no") return YEAR_12_NO_ATAR;
          if (this.ATARChoice === "yes") return YEAR_12_WITH_ATAR;
        } else if (this.journey === "currentYear11") {
          if (this.failingYear11Choice === "no") return YEAR_11_FAILING;
          if (this.failingYear11Choice === "yes") return YEAR_11_PASSING;
        } else {
          return this.journey;
        }
      },
      //Check if the selected course excludes the Teriary Preparation program
      isExcludedTPPCourse: function () {
        if (typeof courseData === "undefined") return false;

        var course = courseData.find(
          (course) =>
            course.dreamCourse == Alpine.store("courseInfo").courseName
        );
        if (course && course.excludeTPP === "1") {
          return true;
        } else {
          return false;
        }
      },
      //Nursing pathways tool has a different layout/number of questions
      isHpiVersion: function () {
        return typeof IS_HPI_VERSION !== "undefined" && IS_HPI_VERSION === true;
      },
      //Checks if the field in question is required for the path/journey the student is on
      isPartOfJourney: function (fieldName) {
        var journey = this.getJourneyPath();
        if (this.journeys[journey] === undefined) return false;
        if (!pathwayData.some((pathway) => pathway.fieldName === fieldName))
          return false;

        if (
          this.journeys[journey].includes(fieldName) &&
          fieldName === "tertiaryStudyProgramChoice"
        ) {
          return !this.isExcludedTPPCourse();
        }

        return this.journeys[journey].includes(fieldName);
      },
      //Check if a particular program has been chosen by student based on their answers
      isChosenProgram: function (fieldName) {
        if (
          this.programs[fieldName] === undefined ||
          this.programs[fieldName] === ""
        )
          return null;
        else if (this.programs[fieldName] === "yes") return true;
        else return false;
      },
      //This function checks if any questions have been answered *It has an edge case for RISE*
      programChoiceAnswers: function (answer) {
        var show = false;
        for (const choice in this.programs) {
          var programChoice = this.programs[choice];
          if (this.isPartOfJourney(choice) && programChoice === answer) {
            if (choice !== PC_RISE || answer !== "no") show = true; //Edge case (don't show black card for RISE)
          }
        }
        return show;
      },
      showBlackCard: function (programName) {
        return (
          this.isPartOfJourney(programName) &&
          this.isChosenProgram(programName) === false &&
          programName !== PC_RISE
        );
      },
      //Stupid edge case because requirements change
      isPassingYear11: function (value) {
        if (
          this.getJourneyPath() === YEAR_11_PASSING &&
          (value === "aspireYear11ProgramChoice" || value === "yes")
        ) {
          return true;
        }
        if (
          this.getJourneyPath() === YEAR_12_WITH_ATAR &&
          (value === "aspireYear11ProgramChoice" || value === "yes")
        ) {
          return true;
        } else {
          return false;
        }
      },
      isUniSubjectCardShown(program) {
        var journey = this.getJourneyPath();
        var pname = program.programName.toLowerCase();
        if (journey === YEAR_11_FAILING) {
          if (
            pname.startsWith("aspire achieve plus") ||
            pname.startsWith("aspire advance")
          )
            return false;
        } else if (journey === YEAR_12_NO_ATAR) {
          if (pname.startsWith("aspire achieve plus")) return false;
        }
        return true;
      },
      //End of stupid edge case
      updateCardBorder: function (e) {
        if (e.target.getAttribute("aria-expanded") === "true") {
          e.target.parentElement.parentElement.classList.add(
            "ds-transparent-border"
          );
        } else {
          e.target.parentElement.parentElement.classList.remove(
            "ds-transparent-border"
          );
        }
      },
      findQuestionDescription: function (fieldName) {
        for (const pathway in pathwayData) {
          if (pathwayData[pathway].fieldName === fieldName) {
            return pathwayData[pathway].question;
          }
        }
        return "No question text found";
      },
      courseFilter: function () {
        Alpine.store("courseInfo").showAutocomplete = false;
        var uniqueCourses = [...new Set(this.availableCourses)];

        var typedIn = Alpine.store("courseInfo").courseName.toLowerCase();

        var autocompleteList = uniqueCourses.filter((course) => {
          var lowercasedCourse = course.toLowerCase();
          return lowercasedCourse.includes(typedIn);
        });

        if (autocompleteList.length > 0) {
          Alpine.store("courseInfo").showAutocomplete = true;
        }

        return autocompleteList.sort();
      },
      autocompleteKeyboardNav: function (index) {
        var courseName = this.courseFilter()[index];
        var max = this.courseFilter().length - 1;

        if (index > max) {
          courseName = this.courseFilter()[max];
        }

        if (index < 0) {
          courseName = this.courseFilter()[0];
        }

        // this.updateCourse(courseName);
        this.$refs.courseNameInput.value = courseName;
        return courseName;
      },
      matchCourse: function () {
        if (
          this.availableCourses.includes(Alpine.store("courseInfo").courseName)
        ) {
          // SetTimeout used because it does not seem to catch the initial scroll, even with $nextTick
          setTimeout(function () {
            document
              .querySelector(".preferred-method-section")
              .scrollIntoView(true, {
                top: 70,
                behavior: "smooth",
              });
          }, 0);

          this.showFootnotes = true;
          this.courseExists = true;
          Alpine.store("courseInfo").showAutocomplete = false;
          var courseURL = this.sortSuitability().reverse()[0].dreamCourseURL;
          Alpine.store("courseInfo").courseURL = courseURL;
          this.getData(courseURL);

          var TPPString = "Tertiary Preparation Program (TPP)";
          var customOrder = [];
          var pathwayCourses = this.filteredCourse().filter(
            (course) => course.pathwayCourseLocation === "PO"
          );
          var LTUCourses = this.filteredCourse().filter(
            (course) =>
              course.pathwayCourseLocation === "LTU" &&
              course.pathwayCourse !== TPPString
          );
          var LTUUGDiplomaCourses = LTUCourses.filter(
            (course) =>
              course.pathwayCourse.toLowerCase().includes("diploma") &&
              !course.pathwayCourse.toLowerCase().includes("graduate")
          );
          var LTUUGCertificateCourses = LTUCourses.filter(
            (course) =>
              course.pathwayCourse.toLowerCase().includes("certificate") &&
              !course.pathwayCourse.toLowerCase().includes("graduate")
          );
          var LTUPGDiplomaCourses = LTUCourses.filter(
            (course) =>
              course.pathwayCourse.toLowerCase().includes("diploma") &&
              course.pathwayCourse.toLowerCase().includes("graduate")
          );
          var LTUPGCertificateCourses = LTUCourses.filter(
            (course) =>
              course.pathwayCourse.toLowerCase().includes("certificate") &&
              course.pathwayCourse.toLowerCase().includes("graduate")
          );
          var LTUAssociateCourses = LTUCourses.filter((course) =>
            course.pathwayCourse.toLowerCase().includes("associate")
          );
          var LTUBachelorCourses = LTUCourses.filter((course) =>
            course.pathwayCourse.toLowerCase().includes("bachelor")
          );
          var LTUMasterCourses = LTUCourses.filter((course) =>
            course.pathwayCourse.toLowerCase().includes("master")
          );
          var LTCACourses = this.filteredCourse().filter(
            (course) => course.pathwayCourseLocation === "LTCA"
          );
          var externalCourses = this.filteredCourse().filter(
            (course) => course.pathwayCourseLocation === "External"
          );
          var TPP = this.filteredCourse().filter(
            (course) => course.pathwayCourse === TPPString
          );

          customOrder = [
            ...pathwayCourses,
            ...LTUMasterCourses,
            ...LTUPGDiplomaCourses,
            ...LTUPGCertificateCourses,
            ...LTUBachelorCourses,
            ...LTUAssociateCourses,
            ...LTUUGDiplomaCourses,
            ...LTUUGCertificateCourses,
            ...TPP,
            ...LTCACourses,
            ...externalCourses,
          ];

          return customOrder;
        }
      },
      filteredCourse: function () {
        return courseData.filter(
          (course) =>
            course.dreamCourse == Alpine.store("courseInfo").courseName
        );
      },
      updateCourse: function (courseName) {
        Alpine.store("courseInfo").courseName = courseName;
        Alpine.store("courseInfo").displayedCourseName = courseName;
        this.matchCourse();
      },
      sortSuitability: function () {
        return this.filteredCourse().sort(function (a, b) {
          return a.suitability - b.suitability;
        });
      },
      getCourseStepObj: function (course) {
        if (course.pathwayCourseLocation === "PO") {
          return [
            "Apply for the course package",
            "Complete/Pass " + course.pathwayCourse,
            "Directly enter " + course.dreamCourse,
          ];
        } else {
          return [course.pathwayCourse, course.method, course.dreamCourse];
        }
      },
      location: function (location) {
        switch (location) {
          case "PO":
          case "LTU":
            return "La Trobe University";
          case "LTCA":
            return "La Trobe College Australia";
          case "External":
            return "External";
        }
      },
      getData: function (dreamCourseURL) {
        // https://gomakethings.com/getting-html-with-fetch-in-vanilla-js/
        fetch(dreamCourseURL)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");

            var img = doc
              .querySelector('meta[property="og:image"]')
              .getAttribute("content");

            return img;
          })
          .catch(function (err) {
            console.warn(`Cannot get metadata (img) from external link.`, err);
          });
      },
      // getDesc: function (url) {
      //   // Uncomment for dev only
      //   // url = "components/sample-course/index.html";

      //   return fetch(url)
      //     .then(function (response) {
      //       return response.text();
      //     })
      //     .then(function (html) {
      //       var parser = new DOMParser();
      //       var pageContent = parser.parseFromString(html, "text/html");

      //       var courseDescription = pageContent
      //         .querySelector('meta[name="description"]')
      //         .getAttribute("content");

      //       if (courseDescription == "error, 404, page not found") {
      //         return "";
      //       }

      //       return courseDescription;
      //     })
      //     .catch(function (err) {
      //       console.warn(
      //         `Cannot get metadata (description) from external link.`,
      //         err
      //       );
      //     });
      // },
      // getImageSrc: function (url) {
      //   // Uncomment for dev only
      //   // url = "components/sample-course/index.html";

      //   return fetch(url)
      //     .then(function (response) {
      //       return response.text();
      //     })
      //     .then(function (html) {
      //       var parser = new DOMParser();
      //       var pageContent = parser.parseFromString(html, "text/html");

      //       var courseImage = pageContent.querySelector(
      //         ".ds-hero__image img"
      //       ).outerHTML;

      //       if (courseImage == "error, 404, page not found") {
      //         return "";
      //       }
      //       return courseImage;
      //     })
      //     .catch(function (err) {
      //       console.warn(
      //         `Cannot get metadata (image) from external link.`,
      //         err
      //       );
      //     });
      // },
      splitDuration: function (duration) {
        var durations = duration.toString().split("-");

        if (durations.length === 1) {
          return durations[0];
        }

        return durations[1];
      },
      disciplineFilter: function () {
        var uniqueDisciplines = [...new Set(this.availableDisciplines.sort())];
        return uniqueDisciplines.filter((discipline) => {
          return this.fullDisciplineName(discipline);
        });
      },
      showCoursesByDiscipline(discipline) {
        var courses = courseData.map((course) => course);
        var coursesByDiscipline = courses.filter(
          (course) =>
            course.discipline === discipline || course.discipline === "md"
        );
        var coursesByName = coursesByDiscipline.map(
          (course) => course.dreamCourse
        );

        Alpine.store("courseInfo").disciplineList = [...new Set(coursesByName)];
        return [...new Set(coursesByName)];
      },
      getStudentTypeLabel(type) {
        const _labelDomLong = `I'm a domestic student (a citizen or permanent resident of
                    Australia, a citizen of New Zealand or a permanent
                    humanitarian visa holder)`;

        const _labelDomShort = `I'm a domestic student`;

        const _labelIntLong = `I'm an international student (not a citizen or permanent
                    resident of Australia, not a citizen of New Zealand or not a
                    permanent humanitarian visa holder)`;
        const _labelIntShort = `I'm an international student`;

        if (type === "dom") {
          return this.isHpiVersion() ? _labelDomLong : _labelDomShort;
        } else {
          return this.isHpiVersion() ? _labelIntLong : _labelIntShort;
        }
      },
      scrollTo(selector) {
        document.querySelector(selector).scrollIntoView(true);
      },
    }));
});
